import { render, staticRenderFns } from "./professional.vue?vue&type=template&id=f3d97950"
import script from "./professional.vue?vue&type=script&lang=js"
export * from "./professional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports